import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="bg-[#281715] text-[#D9C4BC] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-6 max-w-sm text-sm leading-relaxed">Affordable luxury lip care for everyday confidence. Designed in the U.S.</p>
          </div>
          <div className="md:col-span-3 text-sm space-y-3">
            <p className="overline text-[#EBB1B6]">Shop</p>
            <Link to="/product/glasshouse-gloss" className="block hover:text-[#FAF7F2] transition-colors" data-testid="footer-gloss">Glasshouse Gloss</Link>
            <Link to="/product/melt-lip-oil" className="block hover:text-[#FAF7F2] transition-colors" data-testid="footer-oil">Melt Lip Oil</Link>
            <Link to="/product/golden-hour-trio" className="block hover:text-[#FAF7F2] transition-colors" data-testid="footer-trio">Golden Hour Trio</Link>
          </div>
          <div className="md:col-span-4 text-sm space-y-3">
            <p className="overline text-[#EBB1B6]">Say hello</p>
            <p>[Instagram handle]</p>
            <p>[TikTok handle]</p>
            <p>[Support email]</p>
          </div>
        </div>
        <p className="font-display text-[22vw] leading-[0.8] text-[#FAF7F2]/[0.06] mt-16 select-none tracking-tight" aria-hidden="true">LUMI</p>
        <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs pt-6 border-t border-[#4A2E2B]">
          <p>© {new Date().getFullYear()} LUMI BEAUTY. All rights reserved.</p>
          <Link to="/admin" className="hover:text-[#FAF7F2] transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
